import styled from 'styled-components';

export const FinishTitle = styled.h1`
  font-weight: 600;
  font-size: 2rem;
  text-align: center;
  color: ${props => props.theme.colors.grey900};
  margin-bottom: ${props => props.theme.global.gutterSpace}px;
`;

export const FinishSubtitle = styled.div`
  font-size: ${props => props.theme.fontSizes[3]};
  text-align: center;
  color: ${props => props.theme.colors.grey700};
  margin-bottom: ${props => props.theme.global.gutterSpace}px;
`;
